import { TextField } from '@mui/material';
import { COLORS } from '@fupa/fupa-uikit';
import { styled } from '@mui/material/styles';
export const CustomTextField = styled(TextField)({
  '& .MuiInputBase-input': {
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: COLORS.fupaSecondary
    },
    '&.Mui-focused fieldset': {
      borderColor: COLORS.fupaSecondary
    }
  }
});
export const CustomNumberTextField = styled(CustomTextField, {
  shouldForwardProp: prop => prop !== 'maxWidth' && prop !== 'textAlign' && prop !== 'sx'
})(_ref => {
  let {
    maxWidth,
    textAlign
  } = _ref;
  return {
    '& .MuiInputBase-input': {
      textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : 'initial',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      },
      '&[type=number]': {
        MozAppearance: 'textfield'
      }
    },
    '& .MuiOutlinedInput-root': {
      maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 'initial'
    }
  };
});